<app-system-maintenance
  *ngIf="showMessage"
  (closeModal)="closeModal()"
></app-system-maintenance>

<div
  class="row margin-bottom mb48 paperless row-section"
  [ngClass]="{'mb32':isAcmic}"
  *ngIf="
    (((policy?.policyFlags.isEftEligible === 'Y' &&
      policy?.isNewPolicy &&
      autoPay <= 0) ||
      (policy?.policyFlags.isEftEligible === 'Y' && !policy?.isNewPolicy)) &&
      policy?.policyStatus === 'ACTIVE' &&
      !(
        policy?.policyCancellationReason &&
        (policy?.policyCancellationReason.toLowerCase() ===
          'pay - non-payment of insurance premium' ||
          policy?.policyCancellationReason.toLowerCase() ===
            'fpd - failure to pay deposit') &&
        policy?.policyFlags.isEft === 'UNENROLLED'
      )) ||
    ((policy?.policyFlags.isEdfEligible === 'Y' ||
      policy?.policyFlags.isEbillEligible === 'Y') &&
      (policy?.policynumber?.policyNumber.length === 6 ||
        (policy?.policynumber?.policyNumber.length > 6 &&
          policy?.policyStatus === 'ACTIVE')))
  "
>
  <ng-container *ngIf="loading">
    <div class="margin-bottom mb16 text-center width100 loading-no-padding">
      <mapfre-loading></mapfre-loading>
    </div>
  </ng-container>
  <div class="col" *ngIf="!loading">
    <h2 class="title margin-bottom mb16" [ngClass]="{ 'dm-sans-medium': !isAcmic}"
      *ngIf="policy?.company.companyName==='MA'">
      <ng-container *ngIf="!isAcmic; else acmictitle">
        {{ "AUTOPAY_PAPERLESS" | translate }}
    
      </ng-container>
      <ng-template #acmictitle>
        <ng-container
          *ngIf="(policy?.policyFlags?.isEft === 'ENROLLED' && policy?.policyFlags?.isEdf === 'ENROLLED'); else simplifyText">
          <div class="">You’re
            enrolled in</div>
        </ng-container>
        <ng-template #simplifyText>
          <div class="" [ngClass]="{'col-363636-imp': isAcmic}">
            Simplify your billing</div>
        </ng-template>
      </ng-template>
    </h2>
    
    <h2 class="title margin-bottom mb16 autohead "  [ngClass]="{ 'dm-sans-medium': !isAcmic}" *ngIf="policy?.company.companyName!=='MA'">
      {{ "Autopay" }}
    </h2>
    <div class="row">
      <div class="col displayFlexRow mb-3" [ngClass]="{'enroll-text':!isAcmic}">
        <ng-container
          *ngIf="
            policy?.policyFlags.isEftEligible === 'Y' &&
            policy?.billingDetails?.[0]?.badCheckCount === 'N' &&
            policy?.billingDetails?.[0]?.mortageeFlag === 'N'
          "
        >
          <ng-container *ngIf="eft">
            <ng-container [ngSwitch]="policy?.policyFlags.isEft">
              <ng-container *ngIf="isAcmic; else maAutopayMaintenence">
                <!-- <span *ngIf="policy?.policyFlags.isEft!=='UPDATE-PENDING'" class="width75"> {{ "E-PAY" | translate }} </span> -->
                 <a *ngSwitchCase="'ENROLLED'" >
                  <img src="assets/img/images/check-circle-new.svg" alt="payment convenience icon" />
                  <span [routerLink]="['/billing','autopay']" (click)="triggerDatalayer('Manage Autopay')" class="margin-left ml4 manage-autopay-paperless">{{ "MANAGE_AUTOPAY" | translate }}</span>                
                </a>              
                <a
                  *ngSwitchCase="'UNENROLLED'"
                  [routerLink]
                  (click)="onShowMessage();triggerDatalayer('Enroll in Autopay');"
                >
                  <span class="btn-enroll"> {{ "ENROLL_IN_AUTOPAY" | translate }}</span>
                </a>
                <a
                  *ngSwitchCase="'ENROLLMENT-PENDING'"
                  [routerLink]
                  (click)="onShowMessage()"
                >
                  {{ "PENDING_ENROLLMENT" | translate }}
                  <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
                </a>
              </ng-container>
              <ng-template #maAutopayMaintenence>
                <a *ngSwitchCase="'ENROLLED'">
                  <img src="assets/img/images/icon-payment-convenience.svg" alt="payment convenience"/>
                  {{ "ENROLLED_TEXT" | translate }}
                  <span class="width75"> {{ "E-PAY" | translate }} </span>
                </a>              
                <a
                  *ngSwitchCase="'UNENROLLED'"
                  [routerLink]
                  (click)="onShowMessage()" class="enroll-status-button"
                ><img src="assets/img/images/icon-payment-convenience-red.svg" alt="payment convenience" />
                  {{ "NOT_ENROLLED_TEXT" | translate }}
                  <span class="width75"> {{ "E-PAY" | translate }} </span>
                </a>
                <a
                  *ngSwitchCase="'ENROLLMENT-PENDING'"
                  [routerLink]
                  (click)="onShowMessage()" class="enroll-status-button" [ngClass]="{'enroll-pending-button':!isAcmic}"
                ><img src="assets/img/images/icon-payment-convenience-red.svg" alt="payment convenience"/>
                  {{ "PENDING_ENROLLMENT" | translate }}
                  <span> {{ "E-PAY" | translate }} </span>
                </a>
              </ng-template>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!eft">
            <ng-container [ngSwitch]="policy?.policyFlags.isEft">
              <ng-container *ngIf="isAcmic; else maAutopay">
                <!-- <span *ngIf="policy?.policyFlags.isEft!=='UPDATE-PENDING'" class="width75"> {{ "E-PAY" | translate }} </span> -->
                <a *ngSwitchCase="'ENROLLED'" >
                  <img src="assets/img/images/check-circle-new.svg" alt="payment convenience icon" />
                  <span [routerLink]="['/billing','autopay']" (click)="triggerDatalayer('Manage Autopay');" class="margin-left ml4 manage-autopay-paperless">{{ "MANAGE_AUTOPAY" | translate }}</span> 
                </a>              
                <a
                  *ngSwitchCase="'UNENROLLED'"
                  [routerLink]="['/billing', 'autopay']"
                  (click)="triggerDatalayer('Enroll in Autopay');"
                >
                  <span class="btn-enroll"> {{ "ENROLL_IN_AUTOPAY" | translate }}</span>
                </a>
                <a
                  *ngSwitchCase="'ENROLLMENT-PENDING'"
                  [routerLink]="['/billing', 'autopay']"
                >
                  {{ "PENDING_ENROLLMENT" | translate }}
                  <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
                </a>
              </ng-container>
              <ng-template #maAutopay>
                <a *ngSwitchCase="'ENROLLED'">
                  <img src="assets/img/images/icon-payment-convenience.svg" alt="payment convenience" />
                  {{ "ENROLLED_TEXT" | translate }}   
                  <span class="width75"> {{ "E-PAY" | translate }} </span>             
                </a>              
                <a
                  *ngSwitchCase="'UNENROLLED'"
                  [routerLink]="['/billing', 'autopay']" class="enroll-status-button" [ngClass]="{'autopayBtn':!isAcmic}"
                ><img src="assets/img/images/icon-payment-convenience-red.svg" alt="payment convenience" [ngClass]="{'margin-right mr4':!isAcmic}"/>
                  {{ "NOT_ENROLLED_TEXT" | translate }}
                   <span class="width75"> {{ "E-PAY" | translate }}</span>  
                </a>
                <a
                  *ngSwitchCase="'ENROLLMENT-PENDING'"
                  [routerLink]="['/billing', 'autopay']" class="enroll-status-button" [ngClass]="{'enroll-pending-button':!isAcmic}"
                ><img src="assets/img/images/icon-payment-convenience-red.svg" alt="payment convenience"/>
                  {{ "PENDING_ENROLLMENT" | translate }}
                  <span> {{ "E-PAY" | translate }} </span>  
                </a>
              </ng-template>              
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col displayFlexRow" [ngClass]="{'enroll-text':!isAcmic}">
        <ng-container
          *ngIf="
            policy?.policyType !== 'COMMERCIAL_AUTO' &&
              policy?.policyType !== 'GARAGE_KEEPER';
            else commercialTemp
          "
        >
          <ng-container *ngIf="policy?.policyFlags.isEdfEligible === 'Y'">
            <ng-container *ngIf="isPaperless">
              <ng-container *ngIf="isAcmic; else maPaperlessMaintenence">
                <!-- <span class="width75"> {{ "PAPERLESS" | translate }}: </span> -->
                <ng-container [ngSwitch]="true">
                  <a *ngSwitchCase="
                                        policy?.policyFlags.isEdf === 'ENROLLED' ||
                                        policy?.policyFlags.isEdf === 'TRUE'
                                      " >
                    <img src="assets/img/images/check-circle-new.svg" alt="payment convenience icon" />
                    <span [routerLink]="['/billing','paperless']" (click)="triggerDatalayer('Manage Paperless')" class="margin-left ml4 manage-autopay-paperless">{{ "MANAGE_PAPERLESS" |
                      translate }}</span>
                  </a>
                  <a
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'UNENROLLED' ||
                      policy?.policyFlags.isEdf === 'FALSE'
                    "
                    [routerLink]
                    (click)="onShowMessage();triggerDatalayer('Enroll in Paperless');"
                  >
                  <span class="btn-enroll"> {{ "ENROLL_IN_PAPERLESS" | translate }}</span>
                  </a>
                  <a
                    *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'"
                    [routerLink]
                    (click)="onShowMessage()"
                                      >
                    {{ "PENDING_ENROLLMENT" | translate }}
                    <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
                  </a>
                </ng-container>
              </ng-container>
              <ng-template #maPaperlessMaintenence>
                <ng-container [ngSwitch]="true">
                  <a
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'ENROLLED' ||
                      policy?.policyFlags.isEdf === 'TRUE'
                    "
                  ><img src="assets/img/images/icon-write.svg" alt="write icon" />
                    {{ "ENROLLED_TEXT" | translate }} {{ "PAPERLESS" | translate | lowercase }}
                    <!-- <span class="width75"> {{ "PAPERLESS" | translate | lowercase }}</span> -->
                  </a>                
                  <a
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'UNENROLLED' ||
                      policy?.policyFlags.isEdf === 'FALSE'
                    "
                    [routerLink]
                    (click)="onShowMessage()" class="enroll-status-button"
                  >
                  <img src="assets/img/images/icon-write-red.svg" alt="write icon"/>
                    {{ "NOT_ENROLLED_TEXT" | translate }}
                    <span class="width75"> {{ "PAPERLESS" | translate | lowercase }}</span>
                  </a>
                  <a
                    *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'"
                    [routerLink]
                    (click)="onShowMessage()" class="enroll-status-button" [ngClass]="{'enroll-pending-button':!isAcmic}"
                  ><img src="assets/img/images/icon-write-red.svg" alt="write icon"/>
                    {{ "PENDING_ENROLLMENT" | translate }}
                    <span> {{ "PAPERLESS" | translate | lowercase }}</span>
                  </a>                  
                </ng-container>
              </ng-template>              
            </ng-container>
            <ng-container *ngIf="!isPaperless">
              <ng-container *ngIf="isAcmic; else maPaperless">
                <!-- <span class="width75"> {{ "PAPERLESS" | translate }}: </span> -->
                <ng-container [ngSwitch]="true">
                  <a
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'ENROLLED' ||
                      policy?.policyFlags.isEdf === 'TRUE'
                    " 
                  >
                    <img src="assets/img/images/check-circle-new.svg" alt="payment convenience icon" />
                    <span [routerLink]="['/billing','paperless']" (click)="triggerDatalayer('Manage Paperless')" class="margin-left ml4 manage-autopay-paperless">{{ "MANAGE_PAPERLESS" |
                      translate }}</span>               
                  </a>                
                  <a
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'UNENROLLED' ||
                      policy?.policyFlags.isEdf === 'FALSE'
                    "
                    [routerLink]="['/billing', 'paperless']"
                    (click)="triggerDatalayer('Enroll in Paperless')"
                  >
                    <span class="btn-enroll"> {{ "ENROLL_IN_PAPERLESS" | translate }}</span>

                  </a>
                  <a
                    *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'"
                    [routerLink]="['/billing', 'paperless']"
                  >
                    {{ "PENDING_ENROLLMENT" | translate }}
                    <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
                  </a>
                </ng-container>
              </ng-container>
              <ng-template #maPaperless>
              <ng-container [ngSwitch]="true">
                <a
                  *ngSwitchCase="
                    policy?.policyFlags.isEdf === 'ENROLLED' ||
                    policy?.policyFlags.isEdf === 'TRUE'
                  "
                ><img src="assets/img/images/icon-write.svg" alt="write icon" />
                  {{ "ENROLLED_TEXT" | translate }} {{ "PAPERLESS" | translate | lowercase }}
                  <!-- <span class="width75"> {{ "PAPERLESS" | translate | lowercase }}</span>                -->
                </a>                
                <a
                  *ngSwitchCase="
                    policy?.policyFlags.isEdf === 'UNENROLLED' ||
                    policy?.policyFlags.isEdf === 'FALSE'
                  "
                  [routerLink]="['/billing', 'paperless']" class="enroll-status-button" [ngClass]="{'paperlessBtn':!isAcmic}"
                ><img src="assets/img/images/icon-write-red.svg" alt="write icon" [ngClass]="{'margin-right mr4':!isAcmic}"/>
                  {{ "NOT_ENROLLED_TEXT" | translate }} {{ "PAPERLESS" | translate | lowercase }}
                  <!-- <span class="width75"> {{ "PAPERLESS" | translate | lowercase }}</span> -->
                </a>
                <a
                  *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'"
                  [routerLink]="['/billing', 'paperless']" class="enroll-status-button" [ngClass]="{'enroll-pending-button':!isAcmic}"
                ><img src="assets/img/images/icon-write-red.svg" alt="write icon"/>
                  {{ "PENDING_ENROLLMENT" | translate }}
                  <span> {{ "PAPERLESS" | translate | lowercase }}</span>
                </a>                
              </ng-container>
            </ng-template>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #commercialTemp>
          <ng-container *ngIf="policy?.policyFlags.isEbillEligible === 'Y'">
            <ng-container [ngSwitch]="true">
              <ng-container *ngIf="isAcmic; else commercialMaintenence">
                <span class="width75"> {{ "E-BILL_TEXT" | translate }}: </span>
                <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'ENROLLED' ||
                  policy?.policyFlags.isEbill === 'TRUE'
                "
              >
                {{ "ENROLLED_TEXT" | translate }}                
              </a>              
              <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'UNENROLLED' ||
                  policy?.policyFlags.isEbill === 'FALSE'
                "
                [routerLink]="['/billing', 'paperless']"
              >
                {{ "NOT_ENROLLED_TEXT" | translate }}
                <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
              </a>
              <a
                *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLMENT-PENDING'"
                [routerLink]="['/billing', 'paperless']"
              >
                {{ "PENDING_ENROLLMENT" | translate }}
                <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
              </a>
              </ng-container>
              <ng-template #commercialMaintenence>
                <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'ENROLLED' ||
                  policy?.policyFlags.isEbill === 'TRUE'
                "
              ><img src="assets/img/images/icon-write.svg" alt="write icon" />
                {{ "ENROLLED_TEXT" | translate }}    
                <span class="width75"> {{ "E-BILL_TEXT" | translate }}</span>            
              </a>              
              <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'UNENROLLED' ||
                  policy?.policyFlags.isEbill === 'FALSE'
                "
                [routerLink]="['/billing', 'paperless']" class="enroll-status-button" [ngClass]="{'enrl-ebill-button': !isAcmic}" 
              ><img src="assets/img/images/icon-write-red.svg" alt="write icon"/>
                {{ "NOT_ENROLLED_TEXT" | translate }}
                <span class="width75"> {{ "E-BILL_TEXT" | translate }}</span>
              </a>
              <a
                *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLMENT-PENDING'"
                [routerLink]="['/billing', 'paperless']" class="enroll-status-button" [ngClass]="{'enroll-pending-button':!isAcmic}"
              ><img src="assets/img/images/icon-write-red.svg" alt="write icon"/>
                {{ "PENDING_ENROLLMENT" | translate }}
                <span> {{ "E-BILL_TEXT" | translate }}</span>
              </a>
              </ng-template>              
            </ng-container>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isAcmic">
<div class="row margin-bottom mb48 agent row-section">
  <div class="col">
    <h2 class="title margin-bottom mb16 dm-sans-medium">
      {{ "YOUR_AGENT" | translate }}
    </h2>
    <strong>
      <span class="fs-16">{{
        policy?.agent.agentName
      }}</span>
    </strong>
    <p
      class="title-case no-margin-bottom" [ngClass]="{'grey-color':!isAcmic}"
      *ngIf="policy?.agent?.address !== undefined"
    >
      {{ policy.agent.address.streetName | titlecase }}
      {{ policy.agent.address.city | titlecase }},
      {{ policy.agent.address.stateCode }},
      {{ policy.agent.address.zipCode.code }}
    </p>
    <div class="row agent-phone-tab" *ngIf="policy?.agent?.agentISCPhone?.number">
      <div class="col col-tab-desc" [ngClass]="{'grey-color':!isAcmic}">{{ "PHONE" | translate }}:</div>
      <div class="col col-tab-info">
        <a href="tel:{{ policy.agent.agentISCPhone?.number }}" class="mapfre link red-link underline">
          {{ policy.agent.agentISCPhone?.number | formatPhone }}</a
        >
      </div>
    </div>
    <div class="row agent-phone-tab"
      *ngIf="
        policy?.agent?.agentPhone?.number &&
        !policy?.agent?.agentISCPhone?.number
      "
    >
      <div class="col col-tab-desc" [ngClass]="{'grey-color':!isAcmic}">
        {{ "PHONE" | translate }}:
      </div>
      <div class="col col-tab-info">
        <a href="tel:{{ policy.agent.agentPhone?.number }}" class="mapfre link red-link underline">
          {{ policy.agent.agentPhone?.number | formatPhone }}</a
        >
      </div>
    </div>

    <div class="row agent-email-tab" *ngIf="policy?.agent?.agentEmail && policy?.agent?.agentEmail.trim().length > 0">
      <div class="col col-tab-desc" [ngClass]="{'grey-color':!isAcmic}">
        {{ "EMAIL" | translate }}: 
      </div>
      <div class="col col-tab-info">
        <a href="mailto:{{ policy?.agent?.agentEmail }}" class="mapfre link red-link underline">
          {{ policy?.agent?.agentEmail }}</a>
      </div>
    </div>
  </div>
</div>
</div>
<div class="row paperless row-section billing-sidebar"> 
  <ng-container>
    
  </ng-container>
  <div class="col" [ngClass]="{ 'padding-horizontal ph16': !isAcmic}">
    <ng-container *ngIf="isAcmic; else noAcmic">
    <h2 class="title margin-bottom mb16 padding-bottom pb8" [ngClass]="{'col-363636-imp': isAcmic}">
      {{ "BILLING_QUESTIONS" | translate }}
    </h2>
    <div class="font-size xsmall-font bring-up-container">
      <div class="margin-top mt16 margin-bottom mb16 fs-14 col-526570" [ngClass]="{'col-656565-imp': isAcmic}">
        {{"QUESTIONS_ABOUT_POLICY" | translate}}
      </div>
      
      <div class="margin-bottom mb16 billing-modal-sec" id="billing-modal">
         <app-billing-question [buttonText]="'SUBMIT_A_REQUEST'" [isLegacy]="!(policy?.policynumber?.policyNumber.length === 6 || policy?.policynumber?.policyNumber.length === 10)"></app-billing-question>
      </div>
        <div class="billinginfo col-4C4C4C margin-bottom mb16 lh-16">
          <div class="no-margin-bottom billing-sidebar-text" [ngClass]="{'col-363636-imp': isAcmic}">
            {{ "PHONE" | translate }}:
            <a href="tel:18009228276" class="underline billing-phone">1-844-295-4500</a>
          </div>
        </div>
        
        <div class="billinginfo billing-sidebar-text mb10 lh-16" [ngClass]="{'col-363636':isAcmic,'col-4C4C4C':!isAcmic}">
          {{ "CONTACT_CENTER_HOURS_ACMIC" | translate }}
        </div>
        <div class="billinginfo billing-sidebar-text lh-16" [ngClass]="{'col-363636':isAcmic,'col-4C4C4C':!isAcmic}">
          {{ "CONTACT_CENTER_HOURS_2_ACMIC" | translate }}
        </div>
    </div>
  </ng-container>
  <ng-template #noAcmic>
    <ng-container *ngIf="isLivoPolicy; else noAcmicLivo">
      <h2 class="title margin-bottom mb16 dm-sans-medium">
        {{ "BILLING_REQUESTS" | translate }}
      </h2>
      <section class="billing-request-help mt-3">
        <mapfre-button [additionalClasses]="'ghost warn-ghost send-req-btn'"
                    [iconClasses]="'align-middle'"
                    [routerLink]="['/my-insurance/'+ policy?.policynumber?.policyNumber +'/billing-request']">
                    {{ 'SEND_REQUESTS' | translate }}
        </mapfre-button>
        <p class="margin-bottom mb8 col-526570">
          {{ "Or " }}<a routerLink='/contact' class="see-dec">{{ "CONTACT_US_2" | translate }}</a>
          {{ " we're here to help!" }}
        </p>
      </section>
    </ng-container>
  </ng-template>
  <ng-template #noAcmicLivo>
    <h2 class="title margin-bottom mb16 dm-sans-medium">
      {{ "BILLING_QUESTIONS" | translate }}
    </h2>
    <p class="info-medium no-margin-bottom">
      {{ "QUESTIONS_ABOUT_POLICY" | translate }}
    </p>
    <section class="displayFlexRow align-items-start mt-3">
      <img src="assets/img/images/icon-consultancy-blue.svg" alt="consultancy icon"  *ngIf="policy?.company.companyName==='MA'" />
      <div class="margin-top mt4 mb10 ml-2" id="billing-modal">
        <mapfre-button [additionalClasses]="'ghost warn-ghost send-req-btn requestBTN'"
                    [iconClasses]="'align-middle'"
                    [routerLink]="['/my-insurance/'+ policy?.policynumber?.policyNumber +'/other-request']">
                    {{ 'SEND_REQUESTS' | translate }}
        </mapfre-button>
        <ng-container *ngIf="policy?.company.companyName==='MA'">
        <p class="no-margin-bottom mt-2 displayFlexRow" *ngIf="policy?.policynumber?.policyNumber.length > 6">
          {{ "PHONE" | translate }}:
          <a href="tel:18556273737" class=" ml-2 mapfre link red-link underlineBQ font-weight-500">1-855-627-3737</a>
        </p>
        <p class="no-margin-bottom" *ngIf="policy?.policynumber?.policyNumber.length === 6">
          {{ "PHONE" | translate }}:
          <a href="tel:18009228276" class="ml-2 mapfre link red-link underlineBQ font-weight-500">1-800-922-8276</a>
        </p>
        <div class="info-small margin-bottom mb4 mt-2">
          {{ "CONTACT_CENTER_HOURS" | translate }}
        </div>
        <div class="info-small margin-bottom mb4">
          {{ "CONTACT_CENTER_HOURS_2" | translate }}
        </div>
      </ng-container>
      </div>
    </section>
  </ng-template>
  <ng-container *ngIf="isEligibleForUpload || isAcmic">
    <h2 class="title margin-bottom mb16 dm-sans-medium margin-top mt32 padding-top pt16" [ngClass]="{'link-policy-h2 col-363636-imp':isAcmic,'ma-link-policy-h2':!isAcmic}">
      {{ "Need to send us a document?" | translate }}
    </h2>
    <section class="billing-request-help mt-3">
      <app-upload-type-modal [policy]="policy"></app-upload-type-modal>
    </section>
  </ng-container>
  </div>
</div>
